export default {
  form: {
    corporate_name: 'Nome da empresa',
    telephone_companie: 'Telefone da empresa',
    mail_companie: 'E-mail geral da empresa',
    name_user: 'Nome',
    mail_user: 'E-mail',
    password_user: 'Senha',
  },
  buttons: {
    register: 'Cadastrar',
  },
  validate: {
    fild_required: 'Campo obrigatório',
    fild_minlength: 'Quantidade mínima de caracteres não atendida',
    fild_email: 'Digite um e-mail válido',
    fild_telephone: 'Digite um telefone válido',
  },
  text: {
    title: 'Registre-se agora mesmo, é simples, fácil e rápido...',
    title_complement: 'Em menos de um minuto, você já começa a utilizar a nossa plataforma de gestão de clientes!',
    session_companie: 'Dados da empresa',
    session_user: 'Dados de acesso do usuário principal',
    concord_terms: 'Realizando o cadastro em nossa plataforma, você concorda com nossos',
    terms_using: 'termos de uso',
  },
  notifications: {
    success: 'Cadastro realizado com sucesso',
    error: 'Erro ao tentar realizar seu cadastro',
  },
};
